import type { App } from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

// Vite's stand-in for webpack's require.context. The pattern must be a static
// literal, so it matches the whole directory and the Oare* filter is applied
// below rather than inside the glob.
const baseComponents = import.meta.glob('./components/base/*.{vue,js}', {
  eager: true,
});

export default function (app: App) {
  Object.entries(baseComponents).forEach(([path, component]) => {
    const file = path.split('/').pop();

    if (!file || !/^Oare[A-Z]\w+\.(vue|js)$/.test(file)) {
      return;
    }

    // Get PascalCase name of component
    const componentName = upperFirst(
      camelCase(
        // Gets the file name regardless of folder depth
        file.replace(/\.\w+$/, '')
      )
    );

    // Look for the component options on `.default`, which will exist if the
    // component was exported with `export default`, otherwise fall back to the
    // module's root.
    const { default: defaultExport } = component as { default?: unknown };
    app.component(componentName, (defaultExport || component) as never);
  });
}
